export default {
	home: 'ផ្ទះ',
	invoice: 'វិក័យប័ត្រ',
	patients: 'អ្នកជំងឺ',
	doctors: 'គ្រូពេទ្យ',
	stock: 'ស្តុក',
	services: 'សេវាកម្ម',
	settings: 'ការកំណត់',
	contact: 'ទំនាក់ទំនង',
	new_invoice: 'បង្កើតវិក្កយបត្រថ្មី',
	detail_invoice: 'វិក្កយបត្រលំអិត',
	logout: 'ចាកចេញ',
	kk1: 'ក្តាន់',
	kk2: 'ឃ្លោក',
	kk3: 'មាន់',
	kk4: 'បង្កង',
	kk5: 'ក្ដាម',
	kk6: 'ត្រី',
	tsOdd: 'ODD',
	tsEven: 'Even',
	ts1: '1',
	ts2: '2',
	ts3: '3',
	ts4: '4',
	ts5: '5',
	ts6: '6',
	tsBig: 'O',
	tsSmall: 'U'
};
